import AppConfig from '../../Configs/AppConfig';
import { RegisterFormValues } from '../../Modules/Register/Utils/RegisterForm';
import { AppConfigType } from '../../Configs/AppConfigType';

const {
  USER_ENGAGE_API_KEY = '',
  USER_ENGAGE_SCRIPT_URL = '',
  GTM_API_KEY = '',
} = AppConfig as AppConfigType;

export const IsUserEngageEnable = (): boolean =>
  !!USER_ENGAGE_API_KEY && !!USER_ENGAGE_SCRIPT_URL;

export const IsGTMEnable = (): boolean => !!GTM_API_KEY;

export const AddScriptLibrary = (
  urlOfTheLibrary: string,
  async = true
): void => {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary;
  script.async = async;
  document.body.appendChild(script);
};

export const AddCustomScript = (scriptContent: string): void => {
  const script = document.createElement('script');
  script.innerText = scriptContent;
  document.body.appendChild(script);
};

export const SendUELeadEvent = (
  data: RegisterFormValues,
  formName: string
): void => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.userengage('event.lead_www_backup', {
    email: data.email,
    phone_number: data.phoneNumber,
    formularz: formName,
    miasto_kursu: 'unknown',
    url: document.location.href,
  });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.UE.pageHit({
    email: data.email,
    phone_number: data.phoneNumber,
    first_name: data.firstName,
    last_name: data.lastName,
    lead_form: formName,
    miasto_kursu: 'unknown',
    'Źródło leada': 'LMS',
  });
};

export const SendGTMLeadEvent = (
  data: RegisterFormValues,
  formName: string
): void => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.dataLayer.push({
    email: data.email,
    phone_number: data.phoneNumber,
    first_name: data.firstName,
    last_name: data.firstName,
    event: 'cl_lead',
    eventCategory: 'lead_b2c',
    eventAction: formName,
    eventLabel: document.location.href,
    cl_form: formName,
    cl_region: 'unknown',
    page_url: document.location.href,
  });
};

export const ueInitialize = `window.civchat = {apiKey: '${USER_ENGAGE_API_KEY}'};`;
export const gtmInitialize = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','${GTM_API_KEY}');`;
